import React, { Component, Fragment } from 'react';
import classNames from 'classnames';

import Search from './Search';
import SocialLinks from 'components/SocialLinks';
import Button from 'components/Button';
import Icon, { ICON_NAMES } from 'components/Icon';
import Navbar from './Navbar';

class MobileMenu extends Component {

  render() {
    const { onClose, isMenuOpen, isAuth, menuItems, socials, hash } = this.props;

    return (
      <Fragment>
        <div
          className={classNames("main-menu-oerlay", {
            "main-menu-oerlay--open": isMenuOpen,
          })}
          onClick={onClose} />
        <div
          className={classNames("mobile-menu-container", {
            "open": isMenuOpen,
          })}>
          <Button
            bgColor={null}
            className="close-btn main-menu__close-btn"
            onClick={onClose}>
            <Icon name={ICON_NAMES.closeCircle} className="btn-icon icon-close" />
          </Button>
          <div className="mobile-menu-wrapper">
            <div className="mobile-menu-inner">
              {isAuth && <Search />}
              <Navbar isMobile={true} menuItems={menuItems} isAuth={isAuth} hash={hash} />
            </div>
            <div className="mobile-menu-footer">
              <SocialLinks addId={true} socials={socials} />
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default MobileMenu;
